import { Injectable } from '@angular/core';
import { LocationResource } from '@app/shared/resources/location.resource';
import { Observable } from 'rxjs';
import { CoordinatesAndTimezone } from '@app/shared/models/building.interface';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  constructor(private locationResource: LocationResource) {}

  getCoordinatesAndTimezoneByCity(country: string, city: string): Observable<CoordinatesAndTimezone> {
    return this.locationResource.getCoordinatesAndTimezoneByCity(country, city);
  }

  getCitiesOfCountry(country: string): Observable<string[]> {
    return this.locationResource.getCitiesOfCountry(country);
  }

  getCountries(): Observable<string[]> {
    return this.locationResource.getCountries();
  }
}
